import {Component} from "@angular/core";
import {MembershipTypeSearchModel} from "../membership-type-search.model";
import {MembershipTypeEntityModel} from "../membership-type-entity.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-membership-type-search-page",
    templateUrl: "./membership-type-search-page.component.html",
    providers: [provideSearchModel(MembershipTypeSearchModel), provideEntityModel(MembershipTypeEntityModel)]
})
export class MembershipTypeSearchPageComponent extends AbstractSearchPage {
}
